import type { HTMLAttributes } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  appearance?: 'surface' | 'elev'
  padded?: boolean
}

export function Card({
  appearance = 'surface',
  padded = true,
  className = '',
  ...rest
}: CardProps) {
  const bg = appearance === 'elev' ? 'bg-[var(--xr-bg-surface-elev)]' : 'bg-[var(--xr-bg-surface)]'
  const pad = padded ? 'p-5' : ''
  const cls =
    `${bg} border border-[var(--xr-border-default)] rounded-[var(--xr-radius-lg)] shadow-[var(--xr-shadow-sm)] ${pad} ${className}`.trim()
  return <div className={cls} {...rest} />
}
